module.exports = __webpack_public_path__ + "img/img66.962f8a0a.svg";